/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choice/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Choice({
  children,
  viewPath = "/DesignSystem/Choice",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  onClick,
  isSelected,
  hasSubtext,
  subtext = "Subtext",
  text = "Medicare",
  textTransform = "none"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="Choice.Choice:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-2nHSyF': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-2nHSyF': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-2nHSyF': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-2nHSyF': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bc-1-2nHSyF': isSelected ? "rgba(0,147,201, 0.83)" : isHovered ? "rgba(0,147,201, 0.05)" : "#ffffff",'--bc-4-2nHSyF': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 0.83)" : "#ebebeb"}}
 className={`views-block ${styles.Choice1}`}
>
<fromFlow.When is={hasSubtext}>
<div
  data-testid="Choice.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-2nHSyF': isHovered ? "rgba(0,147,201, 1)" : "#edf6ff"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Choice.Text"
  data-view-path={viewPath}
 style={{'--c-7-2nHSyF': isSelected ? "#ffffff" : isHovered ? "#ffffff" : "#0093c9"}}
 className={`views-text ${styles.Text}`}
>
{subtext}
</span>
</div>
</fromFlow.When>
<span
  data-testid="Choice.Text:1"
  data-view-path={viewPath}
 style={{'--tt-8-2nHSyF': textTransform,'--c-7-2nHSyF': isSelected ? "#ffffff" : isHovered ? "rgba(0,147,201, 1)" : "#404040"}}
 className={`views-text ${styles.Text1}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}